(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion_lbrgt"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collapsible-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', ! expanded);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
